import { gql } from '@apollo/client';
import { TypedDocumentNode } from '@graphql-typed-document-node/core';
import { getClient } from '@api/client';
import { TechniciansForTenantsResult } from '@api/generated/graphql';

type TechniciansQueryResult = { technicians: TechniciansForTenantsResult };
type TechniciansQueryVariables = { tenantIds: string[] };

export const getTechniciansQuery: TypedDocumentNode<
  TechniciansQueryResult,
  TechniciansQueryVariables
> = gql`
  query technicians($tenantIds: [ID!]!) {
    technicians(tenantIds: $tenantIds) {
      data {
        tenantId
        technicians {
          id
          name
          phone
        }
      }
      errors {
        tenantId
        message
        code
      }
    }
  }
`;

export const fetchTechnicians = async (
  tenantIds: string[],
): Promise<TechniciansForTenantsResult> => {
  const { data, error } = await getClient().query({
    query: getTechniciansQuery,
    variables: { tenantIds },
    fetchPolicy: 'network-only',
  });

  if (error) {
    throw new Error(error.message);
  }

  return data!.technicians;
};
